(() => {
	"use strict";

	document.addEventListener("DOMContentLoaded", () => {
		/*======================================
	重ねた状態でスクロールで追従
	======================================*/
		const fixedAreas = document.querySelectorAll(".js-fixed-area");

		if (fixedAreas.length > 0) {
			const updateFixedMenus = () => {
				const rootFontSize = parseFloat(
					getComputedStyle(document.documentElement).fontSize,
				);
				const viewportCenter = window.innerHeight / 2;

				fixedAreas.forEach((area) => {
					const menu = area.querySelector(".js-fixed-menu");
					if (!menu) return;

					menu.classList.remove("is-fixed", "is-bottom");

					const areaRect = area.getBoundingClientRect();
					const menuRect = menu.getBoundingClientRect();
					const menuHeight = menu.offsetHeight;
					const menuCenter = menuRect.top + menuHeight / 2;

					const bottomOffsetRem = parseFloat(
						menu.dataset.bottomOffset || "8.5",
					);
					const bottomOffset = bottomOffsetRem * rootFontSize;

					if (
						areaRect.bottom <=
						viewportCenter + menuHeight / 2 + bottomOffset
					) {
						menu.classList.add("is-bottom");
						return;
					}

					if (menuCenter <= viewportCenter) {
						menu.classList.add("is-fixed");
					}
				});
			};

			updateFixedMenus();
			window.addEventListener("scroll", updateFixedMenus, {
				passive: true,
			});
			window.addEventListener("resize", updateFixedMenus);
		}
	});
})();
